class SearchBar {
    constructor() {
        this.searchBar = document.querySelector('.search-bar');

        this.searchBarInput = document.querySelector('.search-bar__input input');
        this.searchBarOpen = document.querySelector('.search-bar__btn-open');
        this.searchBarClose = document.querySelector('.search-bar__btn-close');
        this.mainNav = document.querySelector('.main-navigation');

        this._showNavTimeout = null; // щоб не було накладок таймерів
    }

    /**
     * Initialize the menu functionality.
     */
    init() {
        if (this.searchBarOpen) {
            this.searchBarOpen.addEventListener('click', () => {
                if (this.isMenuOpen === false) {
                    this.searchOpen()
                } 
                // else {
                //     this.searchClose()
                // }
            });
        }

        if (this.searchBarClose) {
            this.searchBarClose.addEventListener('click', () => {
                if (this.isMenuOpen) {
                    this.searchClose()
                }
            });
        }
    }

    /**
     * Open the menu.
     */
    searchOpen() {
        this.searchBar.classList.add('search-bar--active');
        this.searchBarOpen.classList.add('d-none');
        // this.mainNavVisibilityToggle();
        // this.searchBarInput.focus();
        // скасовуємо можливий відкладений показ і ховаємо навігацію одразу
        if (this._showNavTimeout) {
            clearTimeout(this._showNavTimeout);
            this._showNavTimeout = null;
        }
        if (this.mainNav) this.mainNav.classList.add('d-none');
        if (this.searchBarInput) this.searchBarInput.focus();

    }



    /**
     * Close the menu.
     */
    // searchClose() {
    //     this.searchBar.classList.remove('search-bar--active');
    //     this.searchBarOpen.classList.remove('d-none');
    //
    //     this.mainNavVisibilityToggle();
    //     this.clearSearchField()
    // }

    searchClose() {
        if (!this.searchBar) return;

        this.searchBar.classList.remove('search-bar--active');
        if (this.searchBarOpen) {
            this.searchBarOpen.classList.remove('d-none');
        }


        // показати навігацію через 500 мс
        if (this._showNavTimeout) clearTimeout(this._showNavTimeout);
        this._showNavTimeout = setTimeout(() => {
            if (this.mainNav) {
                this.mainNav.classList.remove('d-none');
            }
            this._showNavTimeout = null;
        }, 400);

        this.clearSearchField();
    }

    /**
     * Clear search field.
     */
    // clearSearchField() {
    //     this.searchBarInput.value = '';
    // }
    clearSearchField() {
        if (this.searchBarInput) this.searchBarInput.value = '';
    }

    get isMenuOpen() {
        return this.searchBar
            ? this.searchBar.classList.contains('search-bar--active')
            : false;

    }


    /**
     * .main-navigation should be hidden when desktop search-bar is active
     */
    // mainNavVisibilityToggle() {
    //     this.mainNav.classList.toggle('d-none');
    // }
    //
    // get isMenuOpen() {
    //     return this.searchBar.classList.contains('search-bar--active');
    // }
}

export default SearchBar;